import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import { auth } from "../firebase";
import { useState, useEffect } from "react";
import { Alert } from "./Alert";
import logo from "../assets/Logo.png";

export function ResetPassword() {
  const [params] = useSearchParams();
  const oobCode = params.get("oobCode");

  const [email, setEmail] = useState(""); // 👈 nuevo estado para el correo
  const [newPass, setNewPass] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // 👇 Verificar el código y obtener el email asociado
  useEffect(() => {
    if (!oobCode) return;
    verifyPasswordResetCode(auth, oobCode)
      .then((userEmail) => {
        setEmail(userEmail);
      })
      .catch(() => {
        setError("❌ El enlace de restablecimiento no es válido o ha expirado.");
      });
  }, [oobCode]);

  const handleReset = async () => {
    setError("");
    setMsg("");
    try {
      if (!newPass || newPass.length < 6) {
        return setError("La contraseña debe tener al menos 6 caracteres");
      }

      await confirmPasswordReset(auth, oobCode, newPass);
      setMsg("✅ Contraseña cambiada con éxito. Redirigiendo al login...");
      
      setTimeout(() => {
        navigate("/login");
      }, 2500);
    } catch (err) {
      setError("❌ Error: " + err.message);
    }
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl p-8 w-[350px] text-center">
        
        {error && <Alert message={error} />}
        {msg && <p className="text-green-400 mb-4">{msg}</p>}

        <img src={logo} alt="Logo" className="mx-auto w-40 mb-6" />

        <h1 className="text-2xl font-bold text-white mb-2">
          🔑 Restablecer contraseña
        </h1>

        {/* 👇 Mostrar correo asociado */}
        {email && (
          <p className="text-gray-300 text-sm mb-6">
            Estás restableciendo la contraseña de:  
            <span className="font-semibold text-white"> {email}</span>
          </p>
        )}

        <div className="space-y-4">
          <input
            type="password"
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
            placeholder="Nueva contraseña"
            className="w-full bg-white/20 text-white placeholder-gray-300 rounded-lg p-3 outline-none"
          />

          <button
            onClick={handleReset}
            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-xl font-semibold transition"
          >
            Cambiar contraseña
          </button>
        </div>

        <div className="mt-4">
          <Link to="/login" className="text-sm text-gray-300 hover:underline">
            Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
